(() => {
  const initialize = (root) => {
    if (root.dataset.hsOffersReady) return;
    root.dataset.hsOffersReady = 'true';
    const variant = root.querySelector('.hs-buy-form [name="id"]');
    const purchase = root.querySelector('[data-hs-buy-data]');
    let variants = [];
    try { variants = JSON.parse(purchase?.textContent || '{}').variants || []; } catch {}
    const normalized = (code) => String(code || '').trim().toUpperCase();
    const hasSavedCode = () => document.cookie.split(';').some((value) => /^\s*discount_code=.+/.test(value));
    let queue = Promise.resolve();
    let cartRevision = 0;
    const syncOtherOffers = [];
    const readCart = async (url, expectedPath) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        const destination = new URL(response.url);
        if (!response.ok || destination.origin !== location.origin || destination.pathname !== expectedPath) throw new Error('unconfirmed');
        const cart = await response.json();
        if (!Array.isArray(cart.discount_codes)) throw new Error('unconfirmed');
        return cart.discount_codes;
      } finally { clearTimeout(timeout); }
    };
    root.querySelectorAll('[data-hs-offer]').forEach((offer) => {
      const link = offer.querySelector('[data-hs-offer-apply]');
      const status = offer.querySelector('[data-hs-offer-status]');
      if (!link || !status) return;
      const originalLabel = link.textContent;
      const code = offer.dataset.offerCode;
      const serverNow = Number(offer.dataset.serverNow) * 1000;
      const loadedAt = performance.now();
      const routeRoot = (offer.dataset.routeRoot || '/').replace(/\/?$/, '/');
      const cartPath = `${routeRoot}cart.js`;
      let busy = false;
      let revision = 0;
      const display = (state, message = '') => {
        offer.dataset.offerState = state;
        link.textContent = state === 'applied' ? `✓ ${offer.dataset.appliedLabel}` : state === 'saved' ? offer.dataset.savedLabel : state === 'applying' ? offer.dataset.applyingLabel : originalLabel;
        link.setAttribute('aria-busy', String(state === 'applying'));
        status.textContent = message ? `${code} — ${message}` : '';
      };
      const update = () => {
        const now = (serverNow + performance.now() - loadedAt) / 1000;
        const start = Number(offer.dataset.offerStart) || 0;
        const end = Number(offer.dataset.offerEnd) || 0;
        const current = variants.find((entry) => entry.id === String(variant?.value));
        const active = (!start || start <= now) && (!end || end > now) && current?.available !== false;
        const path = new URL(offer.dataset.productPath, location.origin);
        const eligible = active && path.origin === location.origin;
        offer.hidden = !eligible;
        if (!eligible) { display('idle'); return false; }
        if (variant?.value) path.searchParams.set('variant', variant.value);
        path.hash = 'hs-buy';
        link.href = `${routeRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(path.pathname + path.search + path.hash)}`;
        return true;
      };
      const showResult = (codes) => {
        const saved = codes.find((entry) => normalized(entry.code) === normalized(code));
        if (saved?.applicable === true) display('applied', offer.dataset.appliedMessage);
        else if (saved) display('saved', offer.dataset.savedMessage);
        else display('idle');
        return Boolean(saved);
      };
      const refresh = async () => {
        if (!update() || busy) return;
        const currentRevision = ++revision;
        const currentCartRevision = cartRevision;
        if (!hasSavedCode()) { display('idle'); return; }
        try {
          const codes = await readCart(cartPath, cartPath);
          if (currentRevision === revision && currentCartRevision === cartRevision && !busy && update()) showResult(codes);
        } catch {
          if (currentRevision === revision && currentCartRevision === cartRevision && !busy && update()) display('idle');
        }
      };
      link.addEventListener('click', (event) => {
        if (!update()) { event.preventDefault(); status.textContent = offer.dataset.expiredMessage; return; }
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (busy) return;
        busy = true;
        const currentRevision = ++revision;
        cartRevision++;
        display('applying');
        queue = queue.then(async () => {
          try {
            if (currentRevision !== revision || !update()) return;
            const url = `${routeRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartPath)}`;
            const codes = await readCart(url, cartPath);
            if (currentRevision !== revision || !update()) return;
            if (!showResult(codes)) display('error', offer.dataset.failedMessage);
            syncOtherOffers.forEach((sync) => sync(codes));
          } catch {
            if (currentRevision === revision && update()) display('error', offer.dataset.failedMessage);
          } finally { if (currentRevision === revision) busy = false; }
        });
      });
      syncOtherOffers.push((codes) => { if (!busy && update()) { revision++; showResult(codes); } });
      variant?.addEventListener('change', update);
      addEventListener('pageshow', (event) => {
        if (event.persisted) { revision++; busy = false; display('idle'); }
        refresh();
      });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
      const end = Number(offer.dataset.offerEnd);
      if (end) {
        const tick = () => { update(); const remaining = end * 1000 - serverNow - performance.now() + loadedAt; if (remaining > 0) setTimeout(tick, Math.min(60000, Math.max(100, remaining + 10))); };
        tick();
      }
      refresh();
    });
  };
  document.querySelectorAll('.hs-product').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.hs-product').forEach(initialize));
})();
